import React, {createContext, useState, useEffect } from 'react';
import Formats from "../../../common/src/utils/Formats";
import LocResourcesService from '../services/LocResourcesService';
import { LocResourcesData } from '../../../common/src/utils/types';

export interface LocResourcesContextProps {
    onFormatLocale: (localeKey: string, params?: any) => string;
    onFormatDate: (date: Date) => string;
    locResources: LocResourcesData[] | null;
    onFormatPrice: (amount: number, currency: string) => string;
}

const LocResourcesContext = createContext<Partial<LocResourcesContextProps>>({});

export const LocResourcesProvider: React.FC<any> = ({children, ...props}) => {
    const [locResources, setLocResources] = useState<LocResourcesData[] | null>(null);
    const locale = (props.lang.indexOf("-") !== -1)
            ? props.lang
            : (props.lang.indexOf("_") !== -1)
            ? props.lang.replace('_', '-')
            :`${props.lang}-${props.country}`;
    const formats = Formats( {locResources, locale});
    const metricsService = props.metricsService;
    let  locResourcesService = new LocResourcesService(metricsService);

    const updateLocResources = (): void => {
        locResourcesService.onGetLocResources(props.siteId, props.lang, props.keys)
            .then((data: LocResourcesData[]) => {
                setLocResources(data);
            })
    }

    useEffect(() => {
        updateLocResources();
    }, []);

    const onFormatDate = (date: Date): string => {
        return formats.formatDate(date);
    }

    const onFormatLocale = (localeKey: string, params: any = undefined): string => {
        return formats.locale(localeKey, params);
    }

    const onFormatPrice = (amount: number, currency: string): string => {
        return formats.formatPrice(amount, currency);
    }

    return (
        <LocResourcesContext.Provider
            value={{onFormatLocale, onFormatDate, locResources, onFormatPrice}}>
            {children}
        </LocResourcesContext.Provider>
    )
}

export default LocResourcesContext
